import { EPath } from "constants/path";
import HomePage from "pages/HomePage";
import InviteAdminUserPage from "pages/InviteAdminUserPage";
import PatientManagementPage from "pages/PatientManagementPage";
import PatientDetailPage from "pages/PatientDetailPage";
import PracticeManagementPage from "pages/PracticeManagementPage";
import PracticeUserDetailPage from "pages/PracticeUserDetailPage";
import PrescriptionManagementPage from "pages/PrescriptionManagementPage";
import PrescriptionDetailPage from "pages/PrescriptionDetailPage";
import UserProfilePage from "pages/UserProfilePage";
import VitalSignsHistoryPage from "pages/VitalSignsHistoryPage";
import ActivityHistoryPage from "pages/ActivityHistoryPage";
import SleepHistoryPage from "pages/SleepHistoryPage";
import NutritionHistoryPage from "pages/NutritionHistoryPage";
import BodyMeasurementsHistoryPage from "pages/BodyMeasurementsHistoryPage";
import DailyWellBeingHistoryPage from "pages/DailyWellBeingHistoryPage";

export interface RouteConfig {
  path: string;
  element: React.ComponentType<Record<string, unknown>>;
  protected?: boolean;
  requireOnboarding?: boolean;
  title?: string;
  description?: string;
}

const routeConfig: RouteConfig[] = [
  {
    path: EPath.HOME,
    element: HomePage,
    protected: true,
    title: "Dashboard",
    description: "Main dashboard",
  },
  {
    path: EPath.PROFILE,
    element: UserProfilePage,
    protected: true,
    title: "My Profile",
    description: "View and edit your profile information",
  },
  {
    path: EPath.INVITE_ADMIN_USER,
    element: InviteAdminUserPage,
    protected: true,
    title: "Invite Admin User",
    description: "Invite a new admin user to the portal",
  },
  {
    path: EPath.PATIENT_MANAGEMENT,
    element: PatientManagementPage,
    protected: true,
    title: "Patient Management",
    description: "View and manage patient records across practices",
  },
  {
    path: EPath.PATIENT_DETAIL,
    element: PatientDetailPage,
    protected: true,
    title: "Patient Detail",
    description: "Review a patient profile and data sharing status",
  },
  {
    path: EPath.PRACTICE_MANAGEMENT,
    element: PracticeManagementPage,
    protected: true,
    title: "Practice Management",
    description: "View and manage practice users",
  },
  {
    path: EPath.PRACTICE_USER_DETAIL,
    element: PracticeUserDetailPage,
    protected: true,
    title: "Practice User Detail",
    description: "View detailed practice user information",
  },
  {
    path: EPath.VITAL_SIGNS_HISTORY,
    element: VitalSignsHistoryPage,
    protected: true,
    title: "Vital Signs History",
    description: "View detailed vital signs data",
  },
  {
    path: EPath.ACTIVITY_HISTORY,
    element: ActivityHistoryPage,
    protected: true,
    title: "Activity History",
    description: "View detailed activity data",
  },
  {
    path: EPath.SLEEP_HISTORY,
    element: SleepHistoryPage,
    protected: true,
    title: "Sleep History",
    description: "View detailed sleep data",
  },
  {
    path: EPath.NUTRITION_HISTORY,
    element: NutritionHistoryPage,
    protected: true,
    title: "Nutrition History",
    description: "View detailed nutrition and hydration data",
  },
  {
    path: EPath.BODY_MEASUREMENTS_HISTORY,
    element: BodyMeasurementsHistoryPage,
    protected: true,
    title: "Body Measurements History",
    description: "View detailed body measurements data",
  },
  {
    path: EPath.DAILY_WELL_BEING_HISTORY,
    element: DailyWellBeingHistoryPage,
    protected: true,
    title: "Daily Well Being Score",
    description: "Review monthly daily well being score data",
  },
  {
    path: EPath.PRESCRIPTION_MANAGEMENT,
    element: PrescriptionManagementPage,
    protected: true,
    title: "Prescription Management",
    description: "View and manage prescriptions across all practices",
  },
  {
    path: EPath.PRESCRIPTION_DETAIL,
    element: PrescriptionDetailPage,
    protected: true,
    title: "Prescription Detail",
    description: "View detailed prescription information",
  },
];

export default routeConfig;
